(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-us-custom"] && !Shopify.designMode) return;
  try {
    

jQuery(document).ready(function($) {
  var $cta = $('#tcn-contact-form-cta');
  var $panel = $('#tcn-contact-form-panel');

  function openContactPanel() {
    if (!$panel.length) return;
    $panel.addClass('is-open').attr('aria-hidden', 'false');
    if ($cta.length) {
      $cta.attr('aria-expanded', 'true');
      $cta.find('.tcn-contact-form-cta-text').text('Close enquiry form');
    }
  }

  if ($cta.length && $panel.length) {
    var hasFormFeedback = $panel.find('.tcn-form-alert--success, .tcn-form-alert--error').length > 0;
    var postedViaUrl = false;
    try {
      var pageUrl = new URL(window.location.href);
      postedViaUrl = pageUrl.searchParams.has('contact_posted');
    } catch (e) {}

    if (hasFormFeedback || postedViaUrl) {
      openContactPanel();

      if (hasFormFeedback) {
        var $feedback = $panel.find('.tcn-form-alert').first();
        if ($feedback.length) {
          setTimeout(function() {
            $feedback[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 120);
        }
      }

      try {
        var cleanUrl = new URL(window.location.href);
        if (cleanUrl.searchParams.has('contact_posted')) {
          cleanUrl.searchParams.delete('contact_posted');
          window.history.replaceState({}, document.title, cleanUrl.toString());
        }
      } catch (e) {}
    }

    $cta.on('click', function() {
      var isOpen = $panel.hasClass('is-open');
      $panel.toggleClass('is-open');
      $panel.attr('aria-hidden', isOpen);
      $cta.attr('aria-expanded', isOpen ? 'false' : 'true');
      $cta.find('.tcn-contact-form-cta-text').text(isOpen ? 'Open enquiry form' : 'Close enquiry form');
    });
  }

  (function() {
    var $wrap = $('.page_contact .tcn-select-wrap');
    if (!$wrap.length) return;
    var $native = $('#enquiry_subject');
    var $trigger = $('#tcn-select-trigger');
    var $dropdown = $('#tcn-select-dropdown');
    var $options = $dropdown.find('.tcn-select-option');
    var $subjectError = $('#tcn-contact-subject-error');
    var $form = $('#tcn-contact-form');

    function clearSubjectError() {
      $subjectError.attr('hidden', true);
      $trigger.removeClass('has-error');
    }

    function showSubjectError() {
      $subjectError.removeAttr('hidden');
      $trigger.addClass('has-error');
    }

    function syncTriggerFromSelect() {
      var val = $native.val();
      var $opt = $options.filter('[data-value="' + (val || '') + '"]');
      var text = $opt.length ? $opt.first().text() : 'Select…';
      $trigger.find('.tcn-select-trigger-text').text(text);
      $options.removeClass('is-selected');
      $opt.first().addClass('is-selected');
      if (val) clearSubjectError();
    }

    $trigger.on('click', function(e) {
      e.preventDefault();
      var open = $dropdown.hasClass('is-open');
      $dropdown.toggleClass('is-open');
      $trigger.toggleClass('is-open', !open);
      $trigger.attr('aria-expanded', !open);
      $dropdown.attr('aria-hidden', open);
    });

    $options.on('click', function() {
      var val = $(this).data('value');
      $native.val(val).trigger('change');
      syncTriggerFromSelect();
      $dropdown.removeClass('is-open');
      $trigger.removeClass('is-open').attr('aria-expanded', 'false');
      $dropdown.attr('aria-hidden', 'true');
    });

    $(document).on('click', function(e) {
      if ($dropdown.hasClass('is-open') && !$wrap[0].contains(e.target)) {
        $dropdown.removeClass('is-open');
        $trigger.removeClass('is-open').attr('aria-expanded', 'false');
        $dropdown.attr('aria-hidden', 'true');
      }
    });

    $native.on('change', syncTriggerFromSelect);
    syncTriggerFromSelect();

    $native.closest('form').on('reset', function() {
      setTimeout(syncTriggerFromSelect, 0);
    });

    if ($form.length) {
      $form.on('submit', function(e) {
        if (!$native.val()) {
          e.preventDefault();
          showSubjectError();
          openContactPanel();
          $trigger.focus();
          return false;
        }
        clearSubjectError();
        var $submit = $form.find('.tcn-contact-form__submit');
        $submit.prop('disabled', true);
      });
    }
  })();

  $('.btn-link').click(function() {
    $(this).find('.accordion-icon').toggleClass('active');
    if ($(this).attr('aria-expanded') === "true") {
      $(this).find('.accordion-icon').css('transform', 'rotate(45deg)');
    } else {
      $(this).find('.accordion-icon').css('transform', 'rotate(0deg)');
    }
  });

});







  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hero-banner__track');
      this.slides = Array.from(this.querySelectorAll('.hero-banner__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevBtn = this.querySelector('.hero-banner__arrow--prev');
      this.nextBtn = this.querySelector('.hero-banner__arrow--next');
      this.isFade = this.classList.contains('hero-banner--fade');
      this.total = this.slides.length;
      this.index = 0;
      this.timer = null;

      if (this.total <= 1) return;

      if (this.isFade) this.slides[0].classList.add('is-active');
      this.bindEvents();
      this.startAutoplay();
    }

    goTo(n, transition = true) {
      const prev = this.index;
      this.index = ((n % this.total) + this.total) % this.total;

      if (this.isFade) {
        this.slides[prev].classList.remove('is-active');
        this.slides[this.index].classList.add('is-active');
      } else {
        if (!transition) {
          this.track.style.transition = 'none';
          this.track.style.transform = `translateX(${-this.index * 100}%)`;
          requestAnimationFrame(() => requestAnimationFrame(() => { this.track.style.transition = ''; }));
        } else {
          this.track.style.transform = `translateX(${-this.index * 100}%)`;
        }
      }

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('hero-banner__dot--active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    }

    bindEvents() {
      this.prevBtn?.addEventListener('click', () => { this.stopAutoplay(); this.goTo(this.index - 1); this.startAutoplay(); });
      this.nextBtn?.addEventListener('click', () => { this.stopAutoplay(); this.goTo(this.index + 1); this.startAutoplay(); });

      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this.stopAutoplay();
          this.goTo(Number(dot.dataset.dot));
          this.startAutoplay();
        });
      });

      this.addEventListener('keydown', ({ key }) => {
        if (key === 'ArrowLeft') { this.stopAutoplay(); this.goTo(this.index - 1); this.startAutoplay(); }
        if (key === 'ArrowRight') { this.stopAutoplay(); this.goTo(this.index + 1); this.startAutoplay(); }
      });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true') return;
      const speed = Number(this.dataset.autoplaySpeed) || 5000;
      this.stopAutoplay();
      this.timer = setInterval(() => this.goTo(this.index + 1), speed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('hero-banner')) {
    customElements.define('hero-banner', HeroBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
